
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Worksheet } from "./types";
import { buildSearchIndexFromCurrentData } from "./searchUtils";

export const useWorksheetUpdate = () => {
  const { toast } = useToast();

  const updateWorksheet = async (id: number, updates: Partial<Worksheet>): Promise<boolean> => {
    try {
      // Update the search_index field based on the updates
      const searchUpdateValue = await buildSearchIndexFromCurrentData(id, updates);

      // If we have a new search index, include it in the updates
      const finalUpdates = searchUpdateValue 
        ? { ...updates, search_index: searchUpdateValue, updated_at: new Date().toISOString() }
        : { ...updates, updated_at: new Date().toISOString() };
        
      const { error } = await supabase
        .from("worksheets")
        .update(finalUpdates)
        .eq("id", id);
        
      if (error) throw error;
      
      toast({
        title: "อัปเดตสำเร็จ",
        description: `อัปเดตชีท ID: ${id} เรียบร้อยแล้ว`,
      });
      
      return true;
    } catch (error: any) {
      console.error("Error updating worksheet:", error.message);
      toast({
        title: "เกิดข้อผิดพลาด",
        description: `ไม่สามารถอัปเดตชีทได้: ${error.message}`,
        variant: "destructive"
      });
      return false;
    }
  };

  return { updateWorksheet };
};
